import React, {useState} from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {useAuth0} from "@auth0/auth0-react";
import {withStyles} from '@material-ui/core/styles';
import PropTypes from "prop-types";
import EncodeSansBold from '../../assets/fonts/Encode_Sans/EncodeSans-Bold.ttf';


const styles = (theme) => ({
     menuPaper: {
        backgroundColor: "#3D4977",
        borderRadius: '0',
        paddingTop: 0,
        marginTop: '54px',
        width: '320px',
        height: 'auto',
        shadowColor: "rgba(0, 0, 0, 0.23)",
        shadowOffset: {
            width: -5,
            height: 0
        },
        shadowRadius: 10,
        shadowOpacity: 1,
        '&:hover': {
            backgroundColor: "#012a5d",
        },
    },

    logoutButton: {
        fontSize: '18px',
        color: '#fff',
        fontFamily: EncodeSansBold,
        fontWeight: 'bold',
        textShadowColor: "rgba(82, 82, 82, 0.15)",
        textShadowOffset: {
            width: 0,
            height: 1
        },
        textShadowRadius: 2,
        '&:hover': {
            backgroundColor: "#012a5d",
        },
    },
    imagenPerfil: {
        width: '48px', height: '48px', borderRadius: '50%',
        border: '2px solid #fff',
        margin: '0 10px',
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
            margin: 0
        },
    },
    divMobile: {
        display: 'flex', alignItems: 'center', margin: '0 20px',
        [theme.breakpoints.down('lg')]: {
            margin: 0
        },
    },

    divCerrarSesion: {
        display: 'flex', justifyContent: 'flex-end',
        [theme.breakpoints.down('lg')]: {
            justifyContent: 'center',
        },
        '&:hover': {
            backgroundColor: "#012a5d",
        },
    },



});


function ProfileMenu(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const userImg = props.userImg;
    const {classes} = props;

    const {isAuthenticated, logout} = useAuth0();


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    return isAuthenticated && (
        <div style={{display: 'flex'}}>

            <div className={classes.divMobile}>
                <img
                    aria-label="account of current user"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    src={userImg}
                    className={classes.imagenPerfil}
                />
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted

                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    classes={{paper: classes.menuPaper}}
                >
                    <div className={classes.divCerrarSesion}>
                        <MenuItem
                            onClick={() => logout({returnTo: window.location.origin})}
                            className={classes.logoutButton}
                        >
                            CERRAR SESIÓN
                        </MenuItem>
                    </div>
                </Menu>
            </div>
        </div>
    );
}

ProfileMenu.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProfileMenu);
